import { wrapWc } from 'brinejs/wrapper'
import '@ica-azure/ica-elements/IcaCardRow'

type IcaCardRowProps = React.JSX.IntrinsicElements['tgdb-ica-card-row']

export const IcaCardRow = wrapWc<IcaCardRowProps>('tgdb-ica-card-row', [])